import { BusinessScopeEntry } from './business-scoping-map';

/**
 * Endpoints enrolled into the business scoping map, grouped by the migration
 * unit that owns them. The BusinessContextInterceptor injects the active
 * business id into these requests (query param or body field) unless the caller
 * opts out with BYPASS_BUSINESS_SCOPING.
 *
 * Enrollment is deliberately incremental: an endpoint is added here only once
 * its page/service has been migrated to the active-business lens, so the seam
 * never scopes a surface that still expects multi-business behavior.
 */

/** U6 — core workflow surfaces. */
const U6_ENTRIES: BusinessScopeEntry[] = [
	// Projects list + table (POST /projects/find, POST /projects/find/table-data)
	// carry a singular `businessId` in the request body.
	{ urlPattern: '/projects/find', method: 'POST', inject: 'body', field: 'businessId' }
];

export const BUSINESS_SCOPING_ENTRIES: BusinessScopeEntry[] = [...U6_ENTRIES];
